import React from 'react'

export default function Terms() {

    const handleHome = e => {
        window.location.href = './';
    }
    const handleFaq = e => {
        window.location.href = './#faqs';
    }
    
    return (
        
        <div className='col-xs-12' style={{background:'white'}}>
            <div className='col-xs-4'></div>
            <div className='col-xs-4' style={{fontFamily:'TimesNewRoman', fontSize:'16px', borderLeft:' dashed black', marginTop:'30px', background:'white'}}>

                <h3 style={{fontWeight:'700'}}> Terms And Condition("Terms")</h3>
                <p>Last updated : 30th of Novemeber, 2021</p><br />

                <p style={{color:'black'}}>Please read these Terms and Conditions("Terms", "Terms and Conditions") carefully before using the vhionsexchange.com website operated by "us".</p><br />

                <p style={{color:'black'}}>Your access to and use of the Service is conditioned on your acceptance of and compliance with
                these Terms. These Terms apply to all visitors, users and others who access or use the Service.</p><br />

                <p style={{color:'black', fontWeight:'700'}}>By accessing or using the Service you agree to be bound by these Terms. If you disagree
                with any part of the terms then you may not access the Service.
                </p> <br />

                <h4 style={{color:'black', fontWeight:'700'}}>Content</h4> <br />
                <p style={{color:'black'}}>Our service allows you to buy and sell cryptocurrencies at current affordable rates. Kindly note that during trades, rates and amount of coin in order are subject to change as a result of cryptocurrency price volatility.</p><br />

                <h4 style={{color:'black', fontWeight:'700'}}>Payment</h4> <br />

                <p style={{color:'black'}}>All payments are due upon receipt. If a payment is not received, the buyer will not receive any of the coin placed on order. </p> <br />

                <h4 style={{color:'black', fontWeight:'700'}}>Refund Policy</h4><br />

                <p style={{color:'black'}}>After a buy or sell order has been completed by "us", and you want to reverse the transaction, a 15% fee will be charged.</p> <br />

                <h4 style={{color:'black', fontWeight:'700'}}> Changes </h4> <br />

                <p style={{color:'black'}}> We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is about to be made, we will try to provide at least 7 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.</p> <br />

                <h4 style={{color:'black', fontWeight:'700'}}> Contact Us </h4> <br />

                <p style={{color:'black'}}>If you have any questions about these Terms, please <a href='https://wa.me/2348162624366?text=I%20want%20to%20%20make%20some%20enquiries' target='_blank'>contact us</a></p><br /><br />





                <div style={{display: 'flex', justifyContent:'center', marginTop:'5px', marginButtom:'0', color : 'white', fontSize : '12px', background:'black', width: '100%', left:'0', right:'0', height:'30px'}}> <span onClick={handleHome}><a style={{color : 'white', cursor:'pointer'}}>Home</a> </span> <span style={{marginLeft: '10px'}}onClick={handleFaq}> <a style={{color : 'white', cursor:'pointer'}}>FAQs</a> </span></div>
             <p style={{ dislay:'flex',justifyContent:'center', textAlign:'center', color:'white', fontSize:'10px', background:'black', flexDirection:'column'}}> ⓒ Vhions Exchange 2021</p>


            </div>

            <div className='col-xs-4'></div>

            
            
        
    
            
        </div>
    )
}
